const initState = () => {
  return {
    contacts: [],
    contact: 'all'
  }
}

const candidateContactList = (state=initState(), action) => {
  switch (action.type) {
    case "SET_CANDIDATE_CONTACTS_LIST":
      return Object.assign({}, state, {contacts: action.payload})

    case "SET_CANDIDATE_CONTACTS_LIST_SELECTION":
      return Object.assign({}, state, {contact: action.payload})

    default:
      return state;
  }
}

export default candidateContactList;
